/* eslint-disable no-unused-vars */
import Swiper, { Navigation } from 'swiper';

export default function initQuoteSlider(el) {
    const elContainer = document.querySelectorAll(el);

    if (elContainer.length > 0) {
        new Swiper(el, {
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: '.w-slider-arrow-right',
                prevEl: '.w-slider-arrow-left',
            },
            slidesPerView: 1,
            modules: [Navigation],
        });
    }
}
